import TmcLib from 'tmc-lib';

export const { amountToNumber } = TmcLib.cmnUtil;
export const { mortgageCalculator } = TmcLib.cmnUtil;

export default {};
